import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

export interface ExtendBookingResponse extends AxiosResponse {
  data: {
    success: boolean
    message: string
    extendedBooking?: any // replace with proper type if available
    errorMessage?: string
  }
}

export interface ExtendBookingRequest extends Partial<AxiosRequestConfig> {
  bookingNumber: string
  data: {
    // Add the required payload fields
    // Example:
    extendDays?: number
    newCheckOutDate?: string
  }
}

export function extendBookingApi(
  { bookingNumber, data, ...config }: ExtendBookingRequest,
  axiosInstance: AxiosInstance,
): Promise<ExtendBookingResponse> {
  return axiosInstance({
    method: "post",
    url: `admin/booking/extend`,
    params: { bookingNumber },
    data,
    ...config,
  }) as Promise<ExtendBookingResponse>
}
